import { Component } from "@angular/core";

@Component({
  selector: 'tool-text-editor',
  templateUrl: './text-editor.component.html',
  styleUrls: ['./text-editor.component.scss']
})
export class TextEditorComponent {

  constructor() { }

  html: any;

  textChange(event: any) {
    this.html = event.htmlValue;
  }
}